import styled, { keyframes } from 'styled-components'

export const SidebarInner = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
`

export const ResizeHandle = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 6px;
  transform: translateX(50%);
  background-color: transparent;
  cursor: col-resize;
  flex-shrink: 0;
  user-select: none;
  z-index: 100;
  transition: background-color 0.2s ease;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 2px;
    height: 30px;
    background-color: ${({ theme }) => theme.forecast.secondaryText};
    border-radius: 1px;
    opacity: 0.5;
    transition: all 0.2s ease;
  }

  &:hover {
    background-color: ${({ theme }) => theme.forecast.primary}20;

    &::after {
      opacity: 1;
      background-color: ${({ theme }) => theme.forecast.primary};
    }
  }

  &:active {
    background-color: ${({ theme }) => theme.forecast.primary}30;

    &::after {
      opacity: 1;
      background-color: ${({ theme }) => theme.forecast.primary};
    }
  }
`

export const ThumbnailItemWrapper = styled.button<{ $isActive: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.125rem;
  padding: 0.25rem 0.375rem;
  width: 100%;
  background: transparent;
  border: none;
  cursor: pointer;
  border-radius: 0.25rem;
  margin: 0 auto;
  transition: background 0.15s ease;

  ${({ $isActive, theme }) =>
    $isActive &&
    `
    background: ${theme.forecast.hoverGhostButton};
  `}

  &:hover {
    background: ${({ theme }) => theme.forecast.hoverGhostButton};
  }
`

export const ThumbnailImageContainer = styled.div<{ $isActive: boolean }>`
  width: 100%;
  flex: 1;
  min-height: 0;
  border-radius: 0.25rem;
  overflow: hidden;
  border: 2px solid
    ${({ $isActive, theme }) =>
      $isActive ? theme.forecast.primary : theme.forecast.border};
  transition: border-color 0.15s ease;
  background-color: ${({ theme }) => theme.forecast.cardGroupBackground};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ThumbnailImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
`

const shimmer = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: 200px 0; }
`

export const ThumbnailSkeleton = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.forecast.cardGroupBackground} 25%,
    ${({ theme }) => theme.forecast.hoverButton} 50%,
    ${({ theme }) => theme.forecast.cardGroupBackground} 75%
  );
  background-size: 400px 100%;
  animation: ${shimmer} 1.5s ease-in-out infinite;
`

export const PageLabel = styled.span<{ $isActive: boolean }>`
  font-size: 0.625rem;
  color: ${({ $isActive, theme }) =>
    $isActive ? theme.forecast.defaultText : theme.forecast.secondaryText};
  font-weight: ${({ $isActive }) => ($isActive ? 600 : 400)};
  user-select: none;
`
